import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import { models } from "app/main/std";

const controller = rpcController("ReporteConsultaGuias");

/**Resource del reporte de estadísticas de clientes*/
export const RepConsultaGuias = cacheResource({
Generar: async (
parametros: models.FiltroGuia): Promise<string> =>
await controller("GenerarReporteConsultaGuias", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/reporteconsultaguias.tsx